import useOutsideClick from "hooks/click-outside-hook";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useForm } from "react-hook-form";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface FormValues {
  subscriptionName: string;
  pricePerMonth: number;
  description: string;
}

const SubscriptionPlanModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const modalRef = useOutsideClick(onClose);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (data: FormValues) => {
    console.log("Form Data:", data);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300">
      <div
        ref={modalRef}
        className="relative bg-white p-5 rounded-lg shadow-lg w-[95%] sm:max-w-xl min-h-[300px] transform transition-transform duration-300"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl text-center text-darkCharcoalText font-bold mb-4">
          Subscription Plan
        </h2>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {/* Subscription Name */}
            <div className="flex flex-col gap-1">
              <label className="text-labelText text-base font-semibold">
                Subscription Name
              </label>
              <input
                type="text"
                className="w-full h-[51px] px-2 rounded-lg border border-lightGrayBorder outline-none"
                {...register("subscriptionName", {
                  required: "Subscription name is required",
                })}
              />
              {errors.subscriptionName && (
                <p className="text-red-500 text-sm">
                  {errors.subscriptionName.message}
                </p>
              )}
            </div>

            {/* Price per Month */}
            <div className="flex flex-col gap-1">
              <label className="text-labelText text-base font-semibold">
                Price per Month ($)
              </label>
              <input
                type="text"
                className="w-full h-[51px] px-2 rounded-lg border border-lightGrayBorder outline-none"
                {...register("pricePerMonth", {
                  required: "Price is required",
                  pattern: {
                    value: /^\$?\d+(\.\d{2})?$/,
                    message: "Enter a valid price (e.g., $10.00)",
                  },
                })}
                placeholder="$0.00"
              />
              {errors.pricePerMonth && (
                <p className="text-red-500 text-sm">
                  {errors.pricePerMonth.message}
                </p>
              )}
            </div>
          </div>

          {/* Short Description */}
          <div className="flex flex-col gap-1 mt-3">
            <label className="text-labelText text-base font-semibold">
              Short Description
            </label>
            <textarea
              className="w-full min-h-[100px] px-2 rounded-lg border border-lightGrayBorder outline-none"
              {...register("description", {
                required: "Description is required",
              })}
            />
            {errors.description && (
              <p className="text-red-500 text-sm">
                {errors.description.message}
              </p>
            )}
          </div>

          <button
            type="submit"
            className="bg-goldenOrangeBg text-white w-[140px] rounded-lg h-[40px] mt-4"
          >
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubscriptionPlanModal;
